import React, { Component } from 'react';
import ComboInstancia from './ComboInstancia';

class CriterioDeBusqueda extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        const { data, actions, registrosActivos } = this.props;

        let criterioDeBusqueda = data.criterioDeBusqueda;
        let arrayFiltros = data.arrayFiltros;
        let inhabilitarComboFiltros = arrayFiltros?.length > 4;

        return (
            <div className="VistaInstanciaParametro-Filtros-Contenedor">
                <div>
                    <label className="VistaInstanciaParametro-Filtros-Label-Cabecera">Criterio de búsqueda</label>
                </div>

                {criterioDeBusqueda?.instanciasCombo?.length > 0 && arrayFiltros?.length < 5 ?
                <div className='VistaInstanciaParametro-Marign-Bottom'>
                    <ComboInstancia inhabilitarComboFiltros={inhabilitarComboFiltros} descripcion="Nuevo filtro..." filtro={"nuevoFiltro"} options={criterioDeBusqueda?.instanciasCombo?.length > 0 ? criterioDeBusqueda?.instanciasCombo : data.instanciasComboInicial} selectCombo={actions.selectCombo} />
                </div>
                :
                <div className='VistaInstanciaParametro-Marign-Bottom-Sin-Opciones'></div>
                }

                {arrayFiltros?.length > 0 &&
                    arrayFiltros.map(filtro => (
                        <div>
                            <div className='VistaInstanciaParametro-Filtros-Criterio-Busqueda-Boton VistaInstanciaParametro-Criterio-Busqueda'>
                                <input type='text' disabled={true} value={filtro.instancia.Descripcion} id={filtro.instancia.PropiedadId} className="form-control VistaInstanciaParametro-Filtros-Criterio-Busqueda-Label" />
                                <div className="btn-group">
                                    <button id={filtro.instancia.PropiedadId} type="button" className="btn-tag VistaInstanciaParametro-Filtros-Height-Boton btn-tag.btn-tag-bloqueado btn-tag-closable-right"
                                        onClick={
                                            (e) => {
                                                actions.eliminarFiltro(e.target.id, registrosActivos)
                                            }
                                        }>
                                        <span id={filtro.instancia.PropiedadId} className="ti-close span-closable color-white" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                }

            </div>
        );
    }
}

export default CriterioDeBusqueda;